import { useEffect, useState } from "react";
import { socketService } from "../../../services/socket";

const readLoggerOffset = (config: unknown): number | null => {
  if (!config || typeof config !== "object") return null;
  const value = (config as { loggerOffset?: unknown }).loggerOffset;
  return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : null;
};

/**
 * The timecode offset is global server configuration, not browser state.
 *
 * Logger screens can mount before Socket.IO finishes reconnecting. Asking for
 * the setting only at mount silently drops that request, which leaves the
 * running TC and frozen marks calibrated with different values. Refreshing on
 * every connection makes both paths use the current server value.
 */
export const useLoggerOffset = () => {
  const [offsetSec, setOffsetSec] = useState(0);

  useEffect(() => {
    const applyConfig = (config: unknown) => {
      const next = readLoggerOffset(config);
      if (next !== null) setOffsetSec(next);
    };

    const requestConfig = () => {
      if (!socketService.connected) return;
      socketService.emit("get-logger-config", applyConfig);
    };

    socketService.on("logger:sync_config", applyConfig);
    socketService.on("connect", requestConfig);
    requestConfig();

    return () => {
      socketService.off("logger:sync_config", applyConfig);
      socketService.off("connect", requestConfig);
    };
  }, []);

  return offsetSec;
};
